import { Box, Card, Stack, Typography, alpha } from '@mui/material';
import background from '../../../../images/dashboard-bg.png';
import bee from '../../../../images/bee.svg';
import beeLine from '../../../../images/bee-line.svg';
import box from '../../../../images/box.svg';
import { Link } from '../../../login/components/TermsAndPolicy/TermsAndPolicy.style';

const Dashboard = () => {
  return (
    <Box
      sx={{
        height: 'calc(100vh - 83px)',
        width: '100%',
        background: `url(${background}) no-repeat`,
        backgroundSize: 'cover',
        position: 'relative'
      }}
    >
      <Card
        elevation={0}
        sx={{
          position: 'absolute',
          left: '50%',
          top: '40%',
          transform: 'translate(-50%, -50%)',
          width: '760px',
          backgroundColor: alpha('#0d0d0f', 0.85),
          border: '4px solid #61656C',
          filter: 'drop-shadow(100px 100px 250px rgba(255, 255, 255, 0.20))',
          padding: 6
        }}
      >
        <Box
          sx={{
            background: `url(${beeLine}),url(${box}),url(${bee})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '70px 110px, 345px 60px, 430px -15px'
          }}
          height={210}
        />
        <Stack gap={'30px'}>
          <Typography
            variant='h1'
            sx={{
              overflow: 'hidden',
              color: 'white',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontSize: 30,
              fontStyle: 'normal',
              fontWeight: 300,
              lineHeight: 'normal',
              letterSpacing: 0.5,
              textAlign: 'center'
            }}
          >
            We&apos;re moving and improving!...
          </Typography>

          <Typography component={'p'} textAlign={'center'} fontSize={14}>
            gitStream automation metrics are now part of LinearB SEI+ platform.
            <br />
            Monitor and analyze your automations
            <br />
            <Link
              sx={{ color: '#5467ff', textDecoration: 'none' }}
              href='https://app.linearb.io/automations'
              target='__blank'
            >
              https://app.linearb.io/automations...
            </Link>
          </Typography>
          <Typography component={'p'} textAlign={'center'} fontSize={14}>
            gitStream is free to use
          </Typography>
        </Stack>
      </Card>
    </Box>
  );
};

export default Dashboard;
